import { useState, useEffect } from "react";

export default function TimeField({ label, required, value, onChange, index }) {
  const [time, setTime] = useState("");
  const [ampm, setAmpm] = useState("AM");

  // Initialize state from value
  useEffect(() => {
    if (typeof value === "string") {
      const match = value.match(/^(\d{1,2}:\d{2})(AM|PM)$/i);
      if (match) {
        setTime(match[1]);
        setAmpm(match[2].toUpperCase());
      }
    }
  }, [value]);

  const handleChange = (newTime, newAmpm) => {
    const fullTime = `${newTime}${newAmpm}`;
    onChange(index, "answer", fullTime);
  };

  const handleTimeChange = (e) => {
    const newTime = e.target.value;
    setTime(newTime);
    handleChange(newTime, ampm);
  };

  const handlePeriodChange = (e) => {
    const newAmpm = e.target.value;
    setAmpm(newAmpm);
    handleChange(time, newAmpm);
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium mb-2 text-gray-900">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <div className="flex gap-4 items-center">
        {/* Time Input with Icon */}
        <div className="relative w-full">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </span>
          <input
            type="text"
            value={time}
            onChange={handleTimeChange}
            placeholder="Enter time"
            className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-900 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* AM/PM Dropdown */}
        <select
          value={ampm}
          onChange={handlePeriodChange}
          className="w-1/5 px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-900 bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
        >
          <option>AM</option>
          <option>PM</option>
        </select>
      </div>
    </div>
  );
}
